// Pre-paint theme bootstrap, ported from wwwroot/js/CheckTheme.js. Sets the <html>
// data-theme from the persisted/system preference before first paint so the page never
// flashes the wrong theme (FOUC). Shipped as a classic IIFE bundle served from
// /assets/help-frontend so it satisfies the chat CSP (script-src 'self'); the CSP forbids
// the inline script an at-page-top snippet would require. The resolver is exported so it
// can be unit-tested without a DOM.

import { applyThemeToDocument } from "./theme-apply.js";

export type ResolvedTheme = "light" | "dark";

export interface ThemeBootstrapInputs {
  localStorageTheme: string | null;
  systemPrefersDark: boolean;
}

/**
 * Resolves the initial theme: an explicitly persisted "dark"/"light" wins; otherwise the OS
 * preference decides. Unknown persisted values fall back to the system preference (the app
 * only ever persists "dark"/"light", so this stays behavior-compatible with CheckTheme.js).
 */
export function resolveInitialTheme({
  localStorageTheme,
  systemPrefersDark,
}: ThemeBootstrapInputs): ResolvedTheme {
  if (localStorageTheme === "dark" || localStorageTheme === "light") {
    return localStorageTheme;
  }
  return systemPrefersDark ? "dark" : "light";
}

(function applyInitialTheme(): void {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return;
  }
  const theme = resolveInitialTheme({
    localStorageTheme: window.localStorage.getItem("theme"),
    systemPrefersDark: window.matchMedia("(prefers-color-scheme: dark)")
      .matches,
  });
  applyThemeToDocument(theme, document.documentElement);
})();
